import { useTranslation } from "react-i18next";

import ActionLogDrawerAsync from "../../common/ActionLogDrawerAsync";

/**
 * Backend change-log model name for receipts. The change-log system keys entries
 * by the Sequelize model name (model.constructor.name) — "email_document" for the
 * EmailDocument model (see SMT-1030), consistent with the other models
 * ("transaction", "account", …). Must match exactly what the backend stores.
 */
const EMAIL_DOCUMENT_MODEL_NAME = "email_document";

/**
 * "View logs" trigger for a receipt's field-correction history (SMT-996). Reuses
 * the shared ActionLogDrawerAsync, scoped to this document's change-log entries
 * (field old → new, author, timestamp).
 */
export const ReceiptChangeLog = ({ documentId }: { documentId: string }) => {
  const { t } = useTranslation("ReceiptOverview");

  return (
    <ActionLogDrawerAsync
      title={t("changeLog.title")}
      modelName={EMAIL_DOCUMENT_MODEL_NAME}
      recordIds={[documentId]}
      small
    />
  );
};
